import React, { useState } from "react";
import { Input, Button, Space, Tag, message } from "antd";
import axios from "axios";
import { mainUrl } from "../../helpers/constants";
import { ILabel } from "../../types";

interface IProps {
  selectedSiteIds: string[];
  onSuccess: () => void;
}

export const AddLabelsToSites: React.FC<IProps> = ({
  selectedSiteIds,
  onSuccess,
}) => {
  const [labelInput, setLabelInput] = useState("");
  const [suggestedLabels, setSuggestedLabels] = useState<ILabel[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const searchLabels = async (query: string) => {
    if (!query || query.length < 2) {
      setSuggestedLabels([]);
      return;
    }

    try {
      const instance = axios.create({
        baseURL: mainUrl,
        headers: { "Content-Type": "application/json" },
      });

      const res = await instance.get<any>(`api/v1/label/search?q=${query}`);

      if (res.data.status === "success") {
        setSuggestedLabels(res.data.labels);
      }
    } catch (error) {
      console.error("Error searching labels:", error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLabelInput(value);
    searchLabels(value);
  };

  const handleLabelClick = (labelName: string) => {
    setLabelInput(labelName);
    setSuggestedLabels([]);
  };

  const handleAddLabel = async () => {
    if (!labelInput.trim()) {
      message.error("Введите название метки");
      return;
    }

    if (selectedSiteIds.length === 0) {
      message.error("Выберите хотя бы один сайт");
      return;
    }

    setIsLoading(true);

    try {
      const instance = axios.create({
        baseURL: mainUrl,
        headers: { "Content-Type": "application/json" },
      });

      const res = await instance.post<any>("api/v1/label/add-to-sites", {
        siteIds: selectedSiteIds,
        labelName: labelInput.trim(),
      });

      if (res.data.status === "success") {
        message.success(res.data.message);
        setLabelInput("");
        setSuggestedLabels([]);
        onSuccess();
      }
    } catch (error) {
      console.error("Error adding label:", error);
      message.error("Ошибка при добавлении метки");
    } finally {
      setIsLoading(false);
    }
  };

  if (selectedSiteIds.length === 0) {
    return null;
  }

  return (
    <div className="panel-grey" style={{ marginBottom: 16, padding: 16 }}>
      <Space direction="vertical" style={{ width: "100%" }}>
        <div>
          Выбрано сайтов: <strong>{selectedSiteIds.length}</strong>
        </div>
        <Space>
          <Input
            placeholder="Введите метку"
            value={labelInput}
            onChange={handleInputChange}
            style={{ width: 300 }}
            onPressEnter={handleAddLabel}
          />
          <Button
            type="primary"
            onClick={handleAddLabel}
            loading={isLoading}
            disabled={!labelInput.trim()}
          >
            Добавить метку
          </Button>
        </Space>
        {suggestedLabels.length > 0 && (
          <div>
            <div style={{ marginBottom: 8 }}>Существующие метки:</div>
            <Space wrap>
              {suggestedLabels.map((label) => (
                <Tag
                  key={label._id}
                  color={label.color}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleLabelClick(label.name)}
                >
                  {label.name}
                </Tag>
              ))}
            </Space>
          </div>
        )}
      </Space>
    </div>
  );
};
